const filterSoal = {
    idKurikulum: 0,
    idKelas: 0,
    idMapel: 0,
    idTematik: 0,
    idBab: 0,
    idSubBab: 0,
    idSubTematik: 0,
    idPembTematik: 0,
    kodeOwner: '',
    idUploadHis: 0   
}

export default filterSoal;